import LichSuYTeTypePage from "./LichSuYTeTypePage";

export default LichSuYTeTypePage;
